import { render } from "./AboutView.vue?vue&type=template&id=9b150c90"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=9b150c90&lang=css"

import exportComponent from "C:\\Programowanie\\Projects\\last38minutes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__